// extracted by mini-css-extract-plugin
export var emptyState = "_6m-d";
export var statCard = "_6m-c";
export var table = "_6m-0";
export var tableCell = "_6m-4";
export var tableCellClickable = "_6m-5 _6m-4";
export var tableCellDefault = "_6m-6 _6m-4";
export var tableCellEmpty = "_6m-8";
export var tableCellWithValue = "_6m-7";
export var tableContainer = "_6m-e";
export var tableHeaderWeight = "_6m-1";
export var tableHeaderZone = "_6m-2";
export var tableRowHeader = "_6m-3";
export var viewModeButton = "_6m-9";
export var viewModeButtonActive = "_6m-a _6m-9";
export var viewModeButtonInactive = "_6m-b _6m-9";